import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
export const getOrderReports = createAsyncThunk(
  "/orderreports",
  async (parameters, { rejectWithValue }) => {
    try {

      const method = "/payment/order";

      const { data, errorMessage, isSuccess } = await commonNetwork.get(method, parameters);
      if (isSuccess) {
        return {
          list: data.data || [],
          totalCount: data.totalCount || 0,
          currentPage: data.currentPage || 1,
          isSyncOrders: parameters.isSync
        };
      } else {
        return rejectWithValue(errorMessage);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const orderReportSlice = createSlice({
  name: "orderReport",
  initialState: {
    reports: [],
    totalCount: 0,
    totalRecords: 0,
    currentPage: 1,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    selectedCustomer: "",
    isloadingIntegration: false,
    integrationKey: "",
    integrationResults: [],
    isfetchComplete: false
  },
  reducers: {
    clearState: (state) => {
      state.reports = [];
      state.totalCount = 0;
      state.totalRecords = 0;
      state.currentPage = 1;
      state.selectedCustomer = "";
      state.isfetchComplete = false;
      return state;
    },
    onSelectOrderReportCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
      return state;
    },
    clearOrderReportCustomer: (state, action) => {
      state.selectedCustomer = {};
      return state;
    },
    changeIntegrationLoadingOnReport: (state, action) => {

      state.isloadingIntegration = action.payload;
      return state;
    },
    onSingleIntegrationComplete: (state, action) => {
      state.integrationKey = action.payload.messageGuid;
      var results = [];
      if (action.payload.responseBody) {
        results = JSON.parse(action.payload.responseBody);
      }
      state.integrationResults = results;
      state.isloadingIntegration = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrderReports.fulfilled, (state, { payload }) => {

      const data = payload.list
      state.reports = data;
      state.totalCount = payload.totalCount;
      state.currentPage = payload.currentPage;
      state.totalRecords = data.length;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isfetchComplete = true;
      return state;
    });
    builder.addCase(getOrderReports.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getOrderReports.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState, onSelectOrderReportCustomer, changeIntegrationLoadingOnReport, onSingleIntegrationComplete, clearOrderReportCustomer } = orderReportSlice.actions;

export const orderReportSelector = (state) => state.orderReport;

export const orderReportReducer = orderReportSlice.reducer;
